import { useQuery } from '@apollo/react-hooks';
import throwErrorInDev from '../helpers/throwErrorInDev';
import logWarningInDev from '../helpers/logWarningInDev';
/**
 * Takes in the orderDetails query and order id, and returns the result and
 * some helpers
 */
export default function useOrderDetailQuery({ query, id }) {
    var _a, _b;
    const queryUsesOrderIdParam = 
    // @ts-ignore
    ((_b = (_a = query.definitions[0]) === null || _a === void 0 ? void 0 : _a.variableDefinitions[0]) === null || _b === void 0 ? void 0 : _b.variable.name.value) ===
        'orderId';
    const result = useQuery(query, {
        variables: queryUsesOrderIdParam ? { orderId: id } : { id: id }
    });
    throwErrorInDev(!!result.error, `The API returned an error for the Order query with id ${id}.
    ${result.error}`);
    logWarningInDev(!queryUsesOrderIdParam, 'order(id: Int) has been deprecated. Please update OrderDetail.gql to use the orderId variable.');
    throwErrorInDev(!result.loading && result.data && !result.data.order ? true : false, 'No order field was found in the response. Double-check that your query includes `{ order(orderId: ID!) }`');
    return {
        // Default loading to true for SSR
        loading: result ? result.loading : true,
        error: result.error,
        order: result.data ? result.data.order : null,
        result
    };
}
//# sourceMappingURL=useOrderDetailQuery.js.map